const handleChangeCompareSlider = () => {
	$('.section-compare__nav').on('click', 'a', function(event) {
		const $this = $(this);
		const index = $this.closest('li').index();

		$('.compare-products').find('.js-slider-slides').slick('slickGoTo', index);

		event.preventDefault();
	});
}

handleChangeCompareSlider();
